import { Roles } from '.';

export class LoggedUser {
  displayName!: string;
  user_roles!: Roles[];
  idToken!: string;
  expiresIn?: any;
  refreshToken?: string;
  uuidPassenger?: string;
  displayNameImp?: string;
  email?: string;
  registered?: boolean;
}

export abstract class Role {
  static get_Role(myRole: string): Roles | undefined {
    const match = Object.entries(Roles).find(
      ([key, value]) => myRole.indexOf(value) > -1
    );
    return match ? match[1] : undefined;
  }
}
